// extracted by mini-css-extract-plugin
export default {"base":"base-upKAA","singleColumn":"singleColumn-buK_f","description":"description-lDNSw","half":"half-g8i1V"};